// NOTE: aquí hay un ejemplo [http://athletic.elcorreo.com/noticias/201703/12/real-sociedad-athletic-directo-20170306121619.html?op=cscribble]

export const CONFIG_NAMESPACE = 'vocento.config.scribblelive';
export const DEFAULT_TEMPLATE = 'widget';

export const DEFAULTS = Object.freeze({
  APIToken: 'CFhft3e',
  escribeCapaJs: true, // true -> use template, false -> use IframeApi with embedded template
  ColumnLocation: 'C',
  avatar1: false,
  avatar2: false,
  avatar3: false,
  avatar4: false,
  SL_valor_epigrafe: 'Última hora',
  SL_url_epigrafe: null,
  Scribble_tipoEspecial: '', // Se utiliza para cambiar algunos aspetos de presentación('elecciones-2015' | 'nuevo')
  SL_valor_numeroMensajesPagina: 40,
  SL_valor_evento1Titulo: 'Directo',
  SL_valor_evento1URLPaginaDetalle: null,
  SL_valor_evento2ID: null,
  SL_valor_evento2Titulo: null,
  SL_valor_evento2URLPaginaDetalle: null,
  SL_valor_evento3ID: null,
  SL_valor_evento3Titulo: null,
  SL_valor_evento3URLPaginaDetalle: null,
  SL_valor_evento4ID: null,
  SL_valor_evento4Titulo: null,
  SL_valor_evento4URLPaginaDetalle: null,
  SL_valor_plantilla: '1998',
  Scribble_ancho: undefined, // by default 300
  Scribble_alto: undefined, // by default 450
  Scribble_pageElementId: 'SL_eventoNoticia', // place where comments will be displayed, by default SL_evento
  Scribble_template_twitter: null,
  Scribble_dateFormat: null, // by default DD/MM/YYYY HH:mm:ss
  Scribble_todayDateFormat: null, // by default HH:mm:ss
  Scribble_Iframe_API: '//embed.scribblelive.com/Embed/v5.aspx',
  Scribble_API: '//apiv1.scribblelive.com',
  relativeTimeLanguage: 'es'
});



// WEBPACK FOOTER //
// ./src/constants.js